// frontend/src/component/ProfileTelegramAuth.jsx
import React, { useState } from "react";
import { authFetch } from "../utils/authFetch";

export default function ProfileTelegramAuth({ onBind }) { // добавляем onBind в пропсы
  const [code, setCode] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleBind = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);

   try {
     const { status, data } = await authFetch("/api/accounts/bind-telegram/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code }),
      });

      if (status === 200) {
        setSuccess(true);
        setCode("");  // очищаем поле
        if (onBind) onBind();  // обновляем данные профиля после привязки
      } else {
        setError(data.detail || "Ошибка!");
      }
    } catch (err) {
      setError("Ошибка соединения");
    }
  };
  
  return (
   <div className="mt-4 p-4 border rounded-xl bg-orange-50">
     <div className="text-sm text-gray-700 mb-2">
       1) Откройте бота <a href="https://t.me/mi64bot" target="_blank" rel="noreferrer" className="text-orange-600 underline">@mi64bot</a> → «Привязать аккаунт».<br/>
       2) Вставьте код ниже и нажмите «Привязать».
     </div>
     <form onSubmit={handleBind} className="flex gap-2">
       <input
         type="text"
         value={code}
         onChange={(e) => setCode(e.target.value)}
         required
         placeholder="Код из Telegram"
         className="flex-1 px-3 py-2 border rounded"
       />
       <button type="submit" className="px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded">
         Привязать
       </button>
     </form>
     {success && <div className="text-green-600 mt-2">Telegram успешно привязан!</div>}
     {error && <div className="text-red-600 mt-2">{error}</div>}

     {/* Ссылка на клиента бота */}
     <div className="mt-4">
       <a href="https://t.me/mi64bot" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">
         Открыть клиентского бота
       </a>
     </div>
   </div>
  );
}
